import { render } from "./SpaceTypeList.vue?vue&type=template&id=d4c58b18"
import script from "./SpaceTypeList.vue?vue&type=script&lang=js"
export * from "./SpaceTypeList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__